import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { UrgencyCountdown } from './UrgencyCountdown';
import { CHECKOUT_URL, offerItems } from '../data/content';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-cream-50 px-5 py-20 sm:py-24" data-id="element-109" data-mp="1mmzdg3h6j33l">
      <div className="mx-auto max-w-3xl rounded-3xl border border-rose-200 bg-white p-7 shadow-[0_30px_70px_-50px_rgba(85,61,74,0.45)] sm:p-12" data-id="element-110" data-mp="1hqs5k5583hj0">
        <h2 id="oferta-title" className="text-center font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-left sm:text-5xl" data-id="element-111" data-mp="p0tnitpg4knu">
          Tu oferta completa
        </h2>

        <ul className="mt-8 space-y-3.5" data-id="element-112" data-mp="ywmxc5bs601x">
          {offerItems.map(item => <li key={item} className="flex items-start gap-3 text-base text-plum-600" data-id="element-113" data-mp="2fav9r72u6szu">
              <CheckIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-rose-500" data-id="element-114" data-mp="2ac1ub93zorx1" />
              {item}
            </li>)}
        </ul>

        <div id="comprar" className="mt-10 scroll-mt-24 border-t border-cream-300 pt-8" data-id="element-115" data-mp="ujbme4l4m4w3">
          <p className="text-center text-sm uppercase tracking-[0.2em] text-plum-400 sm:text-left" data-id="element-116" data-mp="ul4yhzeidhbh">
            Valor: <span className="line-through" data-id="element-117" data-mp="13k0171icg9a1">USD 84.00</span>
          </p>
          <p className="mt-3 flex flex-col items-center gap-1 sm:mt-2 sm:flex-row sm:items-baseline sm:gap-3" data-id="element-118" data-mp="13j72mntjgq2z">
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-rose-500" data-id="element-119" data-mp="6rwhc41yt9h5">
              Hoy
            </span>
            <span className="whitespace-nowrap font-display text-5xl font-semibold leading-none text-plum-800 sm:text-6xl" data-id="element-120" data-mp="ftw0b1wjinmq">
              USD 17.00
            </span>
          </p>

          <CtaButton href={CHECKOUT_URL} external className="mt-8 w-full sm:w-auto" data-id="element-121" data-mp="3k8lzept6dv0g">
            Quiero el sistema ahora
          </CtaButton>

          <UrgencyCountdown data-id="element-122" data-mp="3o96023cyjgrc" />

          <p className="mt-5 text-center text-sm leading-relaxed text-plum-400 sm:text-left" data-id="element-123" data-mp="3o84l3nstma4c">
            Pago seguro · Acceso inmediato · 7 días de garantía
            <br data-id="element-124" data-mp="qfmf07mgm9zv" />
            Paga en tu moneda local.
          </p>
        </div>
      </div>
    </section>;
}